import {STORAGE_ALLOWLIST} from 'common/gdpr-constants';

export function validateKeyValue(key: string, value: string): void {
  if (typeof key === `undefined` || key === null || key === ``) {
    throw new Error(`@key cannot be null, undefined, or empty`);
  }

  if (typeof value === `undefined` || value === null || value === ``) {
    throw new Error(`@value cannot be null, undefined, or empty`);
  }
}

// set of localStorage keys that are always allowed regardless of GDPR status
const GDPR_KEY_ALLOWLIST = new Set(STORAGE_ALLOWLIST.map((key) => key.toLowerCase()));

export function isAllowedByGdpr(key) {
  return GDPR_KEY_ALLOWLIST.has(key?.toLowerCase());
}
